import React from 'react';
import { useNavigate } from 'react-router-dom';

const PremiumFeatures = () => {
    const features = [
      {
        icon: 'robot',
        title: 'Advanced OP Exploits',
        description: 'Premium users gain access to advanced exploits targeting specific server plugins and vulnerable permission systems.'
      },
      {
        icon: 'users',
        title: 'Multi-Bot Deployment',
        description: 'Deploy multiple bots simultaneously with different strategies to increase success rates dramatically.'
      },
      {
        icon: 'mask',
        title: 'Undetectable Mode',
        description: 'Premium bots use advanced techniques to avoid detection from popular anti-bot plugins.'
      }
    ];

    const navigate = useNavigate();

    const handleUpgradeClick = () => {
      navigate("/account", { state: { scrollTo: "plans" } });
    }
  
    return (
      <div className="bg-dark-600 rounded-2xl p-6 gradient-bg-purple transform-gpu hover:scale-[1.01] transition-medium border border-dark-400 hover:border-accent-purple/30">
        {/* Background glow effects */}
        <div className="absolute -right-10 -top-10 w-32 h-32 bg-accent-purple opacity-5 rounded-full blur-xl"></div>
        <div className="absolute -left-10 -bottom-10 w-32 h-32 bg-accent-pink opacity-5 rounded-full blur-xl"></div>
        
        <h3 className="font-bold text-lg mb-4 flex items-center group relative z-10">
          <div className="w-10 h-10 rounded-lg bg-accent-purple/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
            <i className="fas fa-crown text-accent-purple"></i>
          </div> 
          Premium Bot Features
          <div className="ml-3 text-xs py-1 px-2 bg-accent-purple/20 rounded-full text-accent-purple opacity-0 group-hover:opacity-100 transition-medium">
            VIP Only
          </div>
        </h3>
        
        <div className="space-y-4 relative z-10">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex p-3 bg-dark-500 rounded-lg hover:bg-dark-400 transition-medium transform-gpu hover:scale-[1.02]"
            >
              <div className="w-8 h-8 rounded-lg bg-accent-purple bg-opacity-20 flex items-center justify-center mr-3 flex-shrink-0 mt-1 transform-gpu hover:rotate-12 transition-medium">
                <i className={`fas fa-${feature.icon} text-accent-purple text-sm`}></i>
              </div>
              <div>
                <p className="font-medium text-sm group-hover:text-white transition-medium">{feature.title}</p>
                <p className="text-xs text-gray-400 group-hover:text-gray-300 transition-medium">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-6 relative z-10">
          <button onClick={handleUpgradeClick} className="w-full py-2.5 bg-gradient-to-r from-accent-purple to-accent-pink hover:opacity-90 rounded-lg text-sm font-medium transition transform-gpu hover:-translate-y-0.5 hover:shadow-glow active:translate-y-0 active:shadow-inner">
            Upgrade to Premium
          </button>
        </div>
      </div>
    );
  };

export default PremiumFeatures;
